import React, {useContext} from 'react';
import {PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer, Tooltip} from 'recharts';
import {ThemeContext} from "../../context/ThemeContext";


const PieChartComponent = ({data}) => {

    const {isDarkMode} = useContext(ThemeContext);

    const color = !isDarkMode ?  "#5D8F15": "#62A575";

    return (
        <ResponsiveContainer width="100%" height={200}>
            <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
                <PolarGrid/>
                <PolarAngleAxis dataKey="intent"/>
                <Tooltip />

                <Radar name="Tickets" dataKey="count" stroke={color} fill={color} fillOpacity={0.6}/>
            </RadarChart>
        </ResponsiveContainer>
    );
};

export default PieChartComponent;
